import { render, staticRenderFns } from "./MoveGroupDialog.vue?vue&type=template&id=3070faa4"
import script from "./MoveGroupDialog.vue?vue&type=script&lang=js"
export * from "./MoveGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports